<template>
  <div class="w-full mb-3">
    <label
      class="w-full text-xs md:text-base mb-1 block font-semibold"
      :for="id">{{ label }} <span
        v-if="required"
        class="text-red-500">*</span></label>
    <input
      :id="id"
      :value="value"
      :class="{
        'border-red-500': false
      }"
      class="disabled:opacity-75 disabled:bg-gray-300 disabled:cursor-not-allowed w-full block focus:border-green-400 focus:outline-none bg-transparent border-b text-sm md:text-base p-2 pl-0"
      type="text"
      @input="$emit('input', $event.target.value)"
      @change="setErrors({})">
    <p
      v-if="errors[id]"
      class="text-2xs md:text-base p-2 pl-0 pt-px text-red-500 mt-1 italic">
      {{ errors[id][0] }}
    </p>
    <p
      v-else
      class="text-2xs md:text-base p-2 pl-0 pt-px text-red-500 mt-1 italic">
      &nbsp;
    </p>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

function nullableString(val) {
  return val === null || typeof val === 'string'
}

export default {
  props: {
    label: {
      validator: nullableString,
      required: true,
    },
    required: {
      type: Boolean,
      default: true,
      required: false,
    },
    id: {
      validator: nullableString,
      required: true,
    },
    value: {
      required: true,
      validator: nullableString,
    }
  },
  emits: ['input'],
  computed: {
    ...mapState(['errors']),
  },
  methods: {
    ...mapMutations(['setErrors']),
  },
}
</script>